var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',[_vm._v("菜单列表")]),_c('div',{staticClass:"menuList"},[_c('ul',_vm._l((_vm.menuItems),function(item){return _c('li',{key:item.id,on:{"click":function($event){return _vm.showComponent(item.component)}}},[_vm._v(_vm._s(item.name))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }